import { useInView, IntersectionOptions } from 'core/common/hooks';

type AnalyticsEventTriggerProps = {
  onTrackEvent: () => void;
  children?: React.ReactNode;
  className?: string;
} & IntersectionOptions;

export const AnalyticsEventTrigger = ({
  onTrackEvent,
  children,
  triggerOnce = true,
  className,
  ...intersectionOptions
}: AnalyticsEventTriggerProps) => {
  const { ref } = useInView({
    ...intersectionOptions,
    triggerOnce,
    onChange(inView) {
      if (!inView) return;

      onTrackEvent();
    },
  });

  return (
    <div className={className} ref={ref}>
      {children}
    </div>
  );
};
